module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/funabashi_ekimae_point3_2-1aa80969972be21791f2417fac27d144.jpg";